module.exports = "https://static.energy5.com/_next/static/images/DocumentSigned-7b0fa7cfe227dcc2a3bb63ea6059a609.png";